import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { authenticateClientAPI } from "./ApiEndPoints";

const initialState: {
  authenticateClientData: any; 
  loading: boolean;
  version: any; 
} = {
  authenticateClientData: {},
  loading: false,
  version: null, 
};

const handleApiError = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    console.error(error);
    return error?.response?.data?.message || "Unknown error";
  } else {
    console.error("Non-Axios error:", error);
    return "Unknown error";
  }
};

export const authenticate = createAsyncThunk(
  "auth/authenticateClient",
  async ({ token, domain }: { token: string; domain: string }) => {
    try {
      const response = await axios.get(
        `${authenticateClientAPI}?token=${token}&domain=${domain}`
      );
      return response.data;
    } catch (error) {
      const errorMessage = handleApiError(error);
      return { message: errorMessage, success: false };
    }
  }
);

const Auth = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(authenticate.pending, (state) => {
        state.loading = true;
      })
      .addCase(authenticate.fulfilled, (state, action) => {
        state.loading = false;
        state.authenticateClientData = action.payload;
        state.version = action.payload?.data?.assignedWidgetVersions[0];
      })
      .addCase(authenticate.rejected, (state, action) => {
        state.loading = false;
        state.authenticateClientData = {
          message: action.error.message,
          success: false,
        };
      });
  },
});

export default Auth.reducer;
